import { Box } from '@hivebrite/design-system/Box';

import type { CustomAttributesForm } from 'hb-react/types';

import { Label, Value } from '../Styling';

type AttributeType = Pick<
  CustomAttributesForm,
  'display_name' | 'display_value' | 'id'
>;

interface CustomAttributesProps {
  customAttributes: AttributeType[];
}

const CustomAttributes = ({ customAttributes = [] }: CustomAttributesProps) => (
  <>
    {customAttributes.map((attribute, index) => (
      <Attribute key={`${index}:${attribute.id}`} attribute={attribute} />
    ))}
  </>
);

interface AttributeProps {
  attribute: Pick<AttributeType, 'display_name' | 'display_value'>;
}

const Attribute = ({ attribute }: AttributeProps) => (
  <Box mt="6px" flexDirection="column">
    <Label mr={1}>{attribute.display_name}</Label>
    <Value>{attribute.display_value || '-'}</Value>
  </Box>
);

export default CustomAttributes;
